import React from 'react'

const DatasourceContext = React.createContext(null)

export default DatasourceContext
